import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-collapse",
  "use": "icon-collapse-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-collapse\"><path d=\"m2 13.3.7.7L7 9.7V12h1V8H4v1h2.3zM14 2.7l-.7-.7L9 6.3V4H8v4h4V7H9.7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol